import React from 'react'

import ListNotifications from '../messenger/ListNotifications'

const PublicTemplate = ({ children }) => {
  return (
    <>
      {children}

      <ListNotifications />
    </>
  )
}

export default PublicTemplate
